import { t } from '@lingui/macro';

const formatJsonText = (text) => {
  try {
    return JSON.stringify(JSON.parse(text), undefined, 2);
  } catch (error) {
    return t`Invalid Payload Format`;
  }
};

export default formatJsonText;
